import { FC, ReactNode } from 'react'
import { CompanyTag, CompanyTagType } from './Tag'

export const Company: FC & CompanyTagType = (): ReactNode => <></>

Company.Tag = CompanyTag
